import React from 'react';
import { Link } from 'react-router-dom';
import { useLocale } from '../contexts/LocaleContext';
import { useNotifications } from '../contexts/NotificationsContext';
import { Button } from './ui/button';

const NOTIFICATION_SETTINGS_HASH = '#notification-settings';

export const DeskNotificationsActions: React.FC = () => {
  const { t } = useLocale();
  const { unreadCount, markAllAsRead } = useNotifications();
  const hasUnread = unreadCount > 0;

  return (
    <div className="flex flex-nowrap items-center justify-end gap-3">
      <Link
        to={`/desk/settings${NOTIFICATION_SETTINGS_HASH}`}
        className="text-sm text-muted-foreground underline-offset-4 hover:text-foreground hover:underline"
      >
        {t('configure_notifications')}
      </Link>
      <Button
        onClick={() => void markAllAsRead()}
        size="sm"
        variant="outline"
        className="text-sm"
        disabled={!hasUnread}
      >
        {t('mark_all_as_read')}
      </Button>
    </div>
  );
};
